import { useLazyGetContractsQuery } from '@/api/queries/contract';

import {
  type PaidSpecContractType,
  type SpecContractType,
} from '../types/contract';

import { useTimerToNextSpecContract } from './timer-to-next-spec-contract';

const useNextSpecContractTime = (
  kind: SpecContractType | PaidSpecContractType,
): number | null => {
  const [getContracts] = useLazyGetContractsQuery();

  return useTimerToNextSpecContract(kind, (): void => {
    getContracts();
  });
};

export { useNextSpecContractTime };
